if (!window.customElements.get('newsletter-form')) {
  if (window.location.search.includes('redirectDebug=1') || window.location.search.includes('rd=1')) {
    localStorage.setItem('daisyRedirectDebug', '1');
  }
  if (window.location.search.includes('redirectDebug=0') || window.location.search.includes('rd=0')) {
    localStorage.removeItem('daisyRedirectDebug');
  }

  const redirectDebugEnabled =
    window.location.search.includes('redirectDebug=1') ||
    window.location.search.includes('rd=1') ||
    localStorage.getItem('daisyRedirectDebug') === '1';

  const TRACE_KEY = 'daisyRedirectTrace';
  const NEWSLETTER_PENDING_KEY = 'daisyNewsletterSubmitPending';
  const KLAVIYO_PUBLIC_KEY = 'Yjjsqh';
  const KLAVIYO_LIST_ID = 'VU8spY';
  const KLAVIYO_REVISION = '2023-12-15';
  const KLAVIYO_ENDPOINT = `https://a.klaviyo.com/client/subscriptions/?company_id=${KLAVIYO_PUBLIC_KEY}`;
  const BACK_IN_STOCK_KLAVIYO_LIST_ID = 'XBZcqn';
  const META_BACK_IN_STOCK_EVENT_NAME = 'BackInStockSignup';
  const RESERVATION_AB_TEST_KEY = 'home_reserve_checkout_path_v1';
  const RESERVATION_AB_STORAGE_KEY = 'daisyReservationAbAssignment';
  const RESERVATION_AB_CONTROL = 'reservation_page';
  const RESERVATION_AB_TAG_PREFIX = 'reservation_ab_variant_';
  const NEWSLETTER_DISCOUNT_STORAGE_KEY = 'daisyNewsletterDiscountCode';
  const NEWSLETTER_OFFER_PROPERTY_NAME = '_daisy_newsletter_offer';
  const NEWSLETTER_OFFER_PROPERTY_VALUE = 'first_release';

  const redirectLog = (...args) => {
    try {
      const trace = JSON.parse(sessionStorage.getItem(TRACE_KEY) || '[]');
      trace.push({ ts: Date.now(), args: args });
      sessionStorage.setItem(TRACE_KEY, JSON.stringify(trace.slice(-120)));
    } catch (_error) {
      // Do not block execution on trace failure.
    }

    if (!redirectDebugEnabled) return;
    console.log('[NewsletterRedirect]', ...args);
  };

  const getEmailFromForm = (form) => {
    if (!form) return '';
    const byName = form.querySelector('input[name="contact[email]"]');
    const byType = form.querySelector('input[type="email"]');
    const raw = (byName?.value || byType?.value || '').trim();
    return raw;
  };

  const isValidEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const emitReservationEvent = (eventName, detail = {}) => {
    const payload = {
      event: eventName,
      reservation_ab_test: RESERVATION_AB_TEST_KEY,
      reservation_ab_variant: detail.variant || '',
      reservation_ab_route: detail.route || '',
      reservation_source_path: window.location.pathname,
      reservation_source_section: detail.section || '',
      reservation_ts: Date.now()
    };

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);

    if (typeof window.gtag === 'function') {
      window.gtag('event', eventName, payload);
    }
  };

  const getReservationAssignment = () => {
    const assignment = {
      test: RESERVATION_AB_TEST_KEY,
      variant: RESERVATION_AB_CONTROL,
      assignedAt: Date.now()
    };

    try {
      localStorage.setItem(RESERVATION_AB_STORAGE_KEY, JSON.stringify(assignment));
    } catch (_error) {
      // Some browsers block storage; the in-memory assignment still works for this click.
    }

    return assignment;
  };

  const storeReservationAssignmentForNextPage = (assignment) => {
    try {
      sessionStorage.setItem(RESERVATION_AB_STORAGE_KEY, JSON.stringify(assignment));
      localStorage.setItem(RESERVATION_AB_STORAGE_KEY, JSON.stringify(assignment));
    } catch (_error) {
      // Non-critical analytics metadata.
    }
  };

  const buildReservationAttributes = (assignment, sourcePath = window.location.pathname) => ({
    _reservation_ab_test: RESERVATION_AB_TEST_KEY,
    _reservation_ab_variant: assignment.variant,
    _reservation_ab_source: sourcePath
  });

  const buildReservationCustomerTags = (assignment) => [
    'newsletter',
    `reservation_ab_test_${RESERVATION_AB_TEST_KEY}`,
    `${RESERVATION_AB_TAG_PREFIX}${assignment.variant}`
  ];

  const appendReservationAbParams = (url, assignment) => {
    if (!url || !assignment) return url;
    try {
      const targetUrl = new URL(url, window.location.origin);
      targetUrl.searchParams.set('reservation_ab_test', assignment.test);
      targetUrl.searchParams.set('reservation_ab_variant', assignment.variant);
      return targetUrl.pathname + targetUrl.search + targetUrl.hash;
    } catch (_error) {
      const separator = url.includes('?') ? '&' : '?';
      return `${url}${separator}reservation_ab_test=${encodeURIComponent(assignment.test)}&reservation_ab_variant=${encodeURIComponent(assignment.variant)}`;
    }
  };

  const updateReservationCartAttributes = async (assignment) => {
    await fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'content-type': 'application/json',
        accept: 'application/json'
      },
      body: JSON.stringify({
        attributes: buildReservationAttributes(assignment)
      })
    });
  };

  const submitShopifyCustomerTags = async ({ form, email, assignment, useKeepalive = false }) => {
    if (!form || !assignment) return null;

    const action = form.getAttribute('action') || window.location.pathname;
    const method = form.getAttribute('method') || 'post';
    const formData = new FormData(form);

    formData.set('contact[email]', email);
    formData.set('contact[tags]', buildReservationCustomerTags(assignment).join(', '));

    return fetch(action, {
      method,
      credentials: 'same-origin',
      keepalive: Boolean(useKeepalive),
      body: formData
    });
  };

  const submitShopifyNewsletter = async ({ form, email, useKeepalive = false }) => {
    if (!form) return null;

    const action = form.getAttribute('action') || window.location.pathname;
    const method = form.getAttribute('method') || 'post';
    const formData = new FormData(form);

    formData.set('contact[email]', email);
    formData.set('contact[tags]', 'newsletter');

    return fetch(action, {
      method,
      credentials: 'same-origin',
      keepalive: Boolean(useKeepalive),
      body: formData
    });
  };

  const addReservationToCart = async ({ variantId, productHandle, assignment }) => {
    const parsedVariantId = Number(variantId);
    if (!parsedVariantId) throw new Error('Missing reservation variant ID.');

    const cartResponse = await fetch('/cart.js', {
      credentials: 'same-origin',
      cache: 'no-store'
    });
    const cart = await cartResponse.json();
    const existingReservation = (cart.items || []).find((item) => (
      item.variant_id === parsedVariantId ||
      item.handle === productHandle ||
      item.product_handle === productHandle
    ));

    await updateReservationCartAttributes(assignment);

    if (existingReservation) {
      return { skipped: true, cart };
    }

    const addResponse = await fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'content-type': 'application/json',
        accept: 'application/json'
      },
      body: JSON.stringify({
        items: [
          {
            id: parsedVariantId,
            quantity: 1,
            properties: buildReservationAttributes(assignment)
          }
        ]
      })
    });

    const payload = await addResponse.json();
    if (!addResponse.ok || payload.status) {
      throw new Error(payload.description || payload.message || 'Unable to add reservation to cart.');
    }

    return { skipped: false, cart: payload };
  };

  const buildKlaviyoPayload = (email, listId = KLAVIYO_LIST_ID) => ({
    data: {
      type: 'subscription',
      attributes: {
        custom_source: 'Daisy Reservation Signup',
        profile: {
          data: {
            type: 'profile',
            attributes: {
              email: email
            }
          }
        }
      },
      relationships: {
        list: {
          data: {
            type: 'list',
            id: listId || KLAVIYO_LIST_ID
          }
        }
      }
    }
  });

  const subscribeToKlaviyo = async (email, useKeepalive = false, listId = KLAVIYO_LIST_ID) => {
    const response = await fetch(KLAVIYO_ENDPOINT, {
      method: 'POST',
      keepalive: Boolean(useKeepalive),
      headers: {
        'content-type': 'application/json',
        revision: KLAVIYO_REVISION
      },
      body: JSON.stringify(buildKlaviyoPayload(email, listId))
    });

    let payload = null;
    try {
      payload = await response.clone().json();
    } catch (_jsonError) {
      try {
        payload = await response.text();
      } catch (_textError) {
        payload = null;
      }
    }

    return {
      ok: response.ok,
      status: response.status,
      payload: payload
    };
  };

  const fireBackInStockMetaEvent = (listId) => {
    if (String(listId || '').trim() !== BACK_IN_STOCK_KLAVIYO_LIST_ID) return;
    window.daisyBackInStockMetaEventState = window.daisyBackInStockMetaEventState || { sent: false };

    if (typeof window.daisyTrackBackInStockSignup === 'function') {
      window.daisyTrackBackInStockSignup();
      return;
    }

    const eventPayload = {
      content_name: 'Daisy One back in stock popup',
      content_category: 'email_signup',
      offer: '50_off',
      list_id: BACK_IN_STOCK_KLAVIYO_LIST_ID
    };

    let hasSent = false;
    const sendMetaEvent = () => {
      if (hasSent || window.daisyBackInStockMetaEventState.sent) return true;
      if (typeof window.fbq !== 'function') return false;
      window.fbq('trackCustom', META_BACK_IN_STOCK_EVENT_NAME, eventPayload);
      hasSent = true;
      window.daisyBackInStockMetaEventState.sent = true;
      redirectLog('meta-back-in-stock-event-fired', {
        eventName: META_BACK_IN_STOCK_EVENT_NAME,
        payload: eventPayload,
        ts: Date.now()
      });
      return true;
    };

    if (sendMetaEvent()) {
      return;
    }

    window.setTimeout(sendMetaEvent, 500);
    window.setTimeout(sendMetaEvent, 1500);

    redirectLog('meta-back-in-stock-event-missing-fbq', {
      eventName: META_BACK_IN_STOCK_EVENT_NAME,
      payload: eventPayload,
      ts: Date.now()
    });
  };

  const isResvipPage = () => window.location.pathname === '/pages/resvipdaisyone';

  const storeNewsletterDiscountCode = (discountCode) => {
    const code = String(discountCode || '').trim();
    if (!code) return;
    try {
      sessionStorage.setItem(NEWSLETTER_DISCOUNT_STORAGE_KEY, code);
      localStorage.setItem(NEWSLETTER_DISCOUNT_STORAGE_KEY, code);
    } catch (_error) {
      // Storage is a convenience only; the discount has already been applied to the cart.
    }
  };

  const getStoredNewsletterDiscountCode = () => {
    try {
      return (
        sessionStorage.getItem(NEWSLETTER_DISCOUNT_STORAGE_KEY) ||
        localStorage.getItem(NEWSLETTER_DISCOUNT_STORAGE_KEY) ||
        ''
      ).trim();
    } catch (_error) {
      return '';
    }
  };

  const setNewsletterOfferOnProductForms = () => {
    if (isResvipPage() || !getStoredNewsletterDiscountCode()) return;

    document.querySelectorAll('product-form form').forEach((form) => {
      if (!form.querySelector('input[name="id"]')) return;
      let input = form.querySelector(`input[name="properties[${NEWSLETTER_OFFER_PROPERTY_NAME}]"]`);
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = `properties[${NEWSLETTER_OFFER_PROPERTY_NAME}]`;
        form.appendChild(input);
      }
      input.value = NEWSLETTER_OFFER_PROPERTY_VALUE;
    });
  };

  const applyNewsletterOfferToCart = async (discountCode) => {
    const code = String(discountCode || '').trim();
    if (!code) return { skipped: true };

    const cartDrawer = document.querySelector('cart-drawer');
    const drawerWasOpen = Boolean(cartDrawer?.classList.contains('active'));
    const sectionsToRender = cartDrawer?.getSectionsToRender?.() || [];
    const cartResponse = await fetch('/cart.js', {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { accept: 'application/json' }
    });
    const cart = await cartResponse.json();
    const daisyLines = (cart.items || [])
      .map((item, index) => ({ item, line: index + 1 }))
      .filter(({ item }) => item.handle === 'daisy-one' || item.product_handle === 'daisy-one');

    if (!daisyLines.length) {
      return { ok: true, payload: cart, skipped: true };
    }

    let payload = cart;
    for (let index = 0; index < daisyLines.length; index += 1) {
      const { item, line } = daisyLines[index];
      const properties = { ...(item.properties || {}) };
      if (properties._daisy_vip_offer) continue;
      properties[NEWSLETTER_OFFER_PROPERTY_NAME] = NEWSLETTER_OFFER_PROPERTY_VALUE;

      const body = { line, properties };
      if (index === daisyLines.length - 1 && sectionsToRender.length) {
        body.sections = sectionsToRender.map((section) => section.id);
        body.sections_url = window.location.pathname;
      }

      const response = await fetch('/cart/change.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'content-type': 'application/json',
          accept: 'application/json'
        },
        body: JSON.stringify(body)
      });
      payload = await response.json().catch(() => null);
      if (!response.ok || payload?.status) {
        throw new Error(payload?.description || payload?.message || 'Unable to apply discount.');
      }
    }

    if (payload) {
      window.shopifyCart = payload;
      if (typeof PUB_SUB_EVENTS !== 'undefined' && typeof publish === 'function') {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'newsletter-form',
          cartData: payload
        });
      }
      if (cartDrawer && drawerWasOpen && payload?.sections) {
        cartDrawer.renderContents(payload);
      }
    }

    return { ok: true, payload };
  };

  customElements.define(
    'newsletter-form',
    class extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.redirectUrl = (this.dataset.redirectUrl || '').trim();
        this.reservationAbEnabled = this.dataset.reservationAbEnabled === 'true';
        this.reservationVariantId = (this.dataset.reservationVariantId || '').trim();
        this.reservationProductHandle = (this.dataset.reservationProductHandle || 'daisy-one-reservation').trim();
        this.klaviyoListId = (this.dataset.klaviyoListId || KLAVIYO_LIST_ID).trim();
        this.discountCode = (this.dataset.discountCode || '').trim();
        this.submitButton = this.querySelector('button[type="submit"]');
        this.confirmMessage = (this.dataset.confirmMessage || 'thank you for subscribing').replace(/\\n/g, '\n').trim();

        if (this.form) {
          this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        }
      }

      showStatusMessage(message, type = 'success') {
        if (!this.form || !message) return;
        let status = this.form.querySelector('[data-newsletter-status]');
        if (!status) {
          status = document.createElement('p');
          status.setAttribute('data-newsletter-status', '');
          status.setAttribute('role', 'status');
          this.form.appendChild(status);
        }
        status.className = `daisy-newsletter-capture__message daisy-newsletter-capture__message--${type}`;
        status.textContent = message;
      }

      async onSubmitHandler(event) {
        event.preventDefault();
        event.stopImmediatePropagation();
        event.stopPropagation();

        if (this.form?.dataset.submitting === '1') return;
        if (this.form) this.form.dataset.submitting = '1';

        sessionStorage.removeItem(NEWSLETTER_PENDING_KEY);
        if (this.form) this.form.removeAttribute('target');

        const email = getEmailFromForm(this.form);
        if (!isValidEmail(email)) {
          redirectLog('klaviyo-submit-invalid-email', {
            email,
            redirectUrl: this.redirectUrl,
            ts: Date.now()
          });
          if (this.form) this.form.dataset.submitting = '0';
          return;
        }

        if (this.submitButton) {
          this.submitButton.setAttribute('aria-disabled', 'true');
          this.submitButton.classList.add('loading');
        }

        const reservationAssignment = this.reservationAbEnabled ? getReservationAssignment() : null;
        const shouldDirectCheckout = false;
        const reservationRedirectUrl = reservationAssignment
          ? appendReservationAbParams(this.redirectUrl, reservationAssignment)
          : this.redirectUrl;

        if (reservationAssignment) {
          storeReservationAssignmentForNextPage(reservationAssignment);
          emitReservationEvent('daisy_reserve_click', {
            variant: reservationAssignment.variant,
            route: shouldDirectCheckout ? 'direct_checkout' : 'reservation_page',
            section: this.closest('[id]')?.id || ''
          });
        }

        const shopifyCustomerTagPromise = reservationAssignment
          ? submitShopifyCustomerTags({
              form: this.form,
              email,
              assignment: reservationAssignment,
              useKeepalive: true
            }).catch((error) => {
              redirectLog('shopify-customer-tag-error', {
                message: error && error.message ? String(error.message) : String(error || ''),
                email,
                variant: reservationAssignment.variant,
                ts: Date.now()
              });
              return null;
            })
          : Promise.resolve(null);

        let noRedirectFailed = false;

        if (this.redirectUrl) {
          // Do not block page transition on Klaviyo response.
          subscribeToKlaviyo(email, true, this.klaviyoListId)
            .then((result) => {
              redirectLog('klaviyo-submit-result', {
                ok: result.ok,
                status: result.status,
                revision: KLAVIYO_REVISION,
                listId: this.klaviyoListId,
                payload: result.payload,
                errors: result && result.payload && result.payload.errors ? result.payload.errors : null,
                email,
                redirectUrl: reservationRedirectUrl,
                ts: Date.now()
              });
            })
            .catch((error) => {
              redirectLog('klaviyo-submit-error', {
                message: error && error.message ? String(error.message) : String(error || ''),
                email,
                redirectUrl: reservationRedirectUrl,
                ts: Date.now()
              });
            });
        } else {
          let result = null;
          try {
            result = await subscribeToKlaviyo(email, false, this.klaviyoListId);
            await submitShopifyNewsletter({
              form: this.form,
              email,
              useKeepalive: false
            });
            redirectLog('klaviyo-submit-result', {
              ok: result.ok,
              status: result.status,
              revision: KLAVIYO_REVISION,
              listId: this.klaviyoListId,
              payload: result.payload,
              errors: result && result.payload && result.payload.errors ? result.payload.errors : null,
              email,
              redirectUrl: this.redirectUrl,
              ts: Date.now()
            });
            if (!result.ok) {
              noRedirectFailed = true;
              this.showStatusMessage('please try again', 'error');
            } else {
              fireBackInStockMetaEvent(this.klaviyoListId);
              if (this.discountCode) {
                try {
                  storeNewsletterDiscountCode(this.discountCode);
                  setNewsletterOfferOnProductForms();
                  await applyNewsletterOfferToCart(this.discountCode);
                } catch (discountError) {
                  redirectLog('cart-discount-apply-error', {
                    message: discountError && discountError.message ? String(discountError.message) : String(discountError || ''),
                    discountCode: this.discountCode,
                    email,
                    ts: Date.now()
                  });
                  noRedirectFailed = true;
                  this.showStatusMessage('please try again', 'error');
                }
              }
            }
          } catch (error) {
            redirectLog('klaviyo-submit-error', {
              message: error && error.message ? String(error.message) : String(error || ''),
              email,
              redirectUrl: this.redirectUrl,
              ts: Date.now()
            });
            noRedirectFailed = true;
            this.showStatusMessage('please try again', 'error');
          }
        }

        if (this.submitButton) {
          this.submitButton.removeAttribute('aria-disabled');
          this.submitButton.classList.remove('loading');
        }
        if (this.form) this.form.dataset.submitting = '0';

        if (this.redirectUrl) {
          await shopifyCustomerTagPromise;

          if (shouldDirectCheckout) {
            try {
              await addReservationToCart({
                variantId: this.reservationVariantId,
                productHandle: this.reservationProductHandle,
                assignment: reservationAssignment
              });
              emitReservationEvent('daisy_reserve_direct_checkout_started', {
                variant: reservationAssignment.variant,
                route: 'direct_checkout',
                section: this.closest('[id]')?.id || ''
              });
              window.location.assign('/checkout');
              return;
            } catch (error) {
              redirectLog('direct-checkout-add-error', {
                message: error && error.message ? String(error.message) : String(error || ''),
                variantId: this.reservationVariantId,
                redirectUrl: reservationRedirectUrl,
                ts: Date.now()
              });
              emitReservationEvent('daisy_reserve_direct_checkout_error', {
                variant: reservationAssignment.variant,
                route: 'reservation_page_fallback',
                section: this.closest('[id]')?.id || ''
              });
            }
          }

          if (reservationAssignment) {
            try {
              await updateReservationCartAttributes(reservationAssignment);
            } catch (_error) {
              // The reservation page still receives the variant in the URL/session storage.
            }
          }
          window.location.assign(reservationRedirectUrl);
          return;
        }

        redirectLog('klaviyo-submit-complete-no-redirect', {
          email,
          redirectUrl: this.redirectUrl,
          ts: Date.now()
        });
        if (noRedirectFailed) return;
        this.showStatusMessage(this.confirmMessage, 'success');
        if (this.form) this.form.reset();
      }
    }
  );

  setNewsletterOfferOnProductForms();
  if (window.MutationObserver) {
    const newsletterOfferObserver = new MutationObserver(() => setNewsletterOfferOnProductForms());
    newsletterOfferObserver.observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }
}

if (!window.daisyDiscountPopupController) {
  window.daisyDiscountPopupController = true;

  const modalState = new WeakMap();
  const observedModals = new WeakSet();

  const getState = (modal) => {
    if (!modalState.has(modal)) {
      modalState.set(modal, {
        closeTimer: null,
        previousFocus: null,
        previousBodyOverflow: ''
      });
    }
    return modalState.get(modal);
  };

  const spinDaisyDiscountCloseButton = (modal) => {
    const closeButton = modal?.querySelector('[data-daisy-discount-modal-close]');
    if (!closeButton) return;
    closeButton.classList.remove('is-spinning');
    void closeButton.offsetWidth;
    closeButton.classList.add('is-spinning');
    window.setTimeout(() => closeButton.classList.remove('is-spinning'), 560);
  };

  const resetDaisyDiscountModalSuccess = (modal) => {
    modal?.classList.remove('is-success');
    modal?.querySelectorAll('[data-newsletter-status]').forEach((status) => status.remove());
    modal?.querySelector('form')?.reset();
  };

  const watchDaisyDiscountModal = (modal) => {
    if (!modal || !window.MutationObserver || observedModals.has(modal)) return;
    observedModals.add(modal);
    const observer = new MutationObserver(() => {
      const successMessage = modal.querySelector('.daisy-newsletter-capture__message--success');
      if (!successMessage || modal.classList.contains('is-success')) return;
      modal.classList.add('is-success');
      spinDaisyDiscountCloseButton(modal);
    });
    observer.observe(modal, {
      attributes: true,
      attributeFilter: ['class'],
      childList: true,
      subtree: true
    });
  };

  const hasActivePageScrollLock = () => (
    document.documentElement.classList.contains('video-banner-desktop--locked') ||
    document.body.classList.contains('video-banner-desktop--locked') ||
    document.body.classList.contains('home-fullscreen-image-up--locked') ||
    document.body.classList.contains('home-fullscreen-image-desktop--locked') ||
    document.body.classList.contains('policy-modal-open')
  );

  const restoreBodyOverflow = (previousBodyOverflow) => {
    if (previousBodyOverflow === 'hidden' && !hasActivePageScrollLock()) {
      document.body.style.overflow = '';
      return;
    }
    document.body.style.overflow = previousBodyOverflow || '';
  };

  const openDaisyDiscountModal = (modal, trigger) => {
    if (!modal) return;
    const state = getState(modal);
    if (state.closeTimer) {
      window.clearTimeout(state.closeTimer);
      state.closeTimer = null;
    }
    resetDaisyDiscountModalSuccess(modal);
    watchDaisyDiscountModal(modal);
    state.previousFocus = trigger || document.activeElement;
    state.previousBodyOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    modal.hidden = false;
    window.requestAnimationFrame(() => {
      modal.classList.add('is-open');
      spinDaisyDiscountCloseButton(modal);
      modal.querySelector('[data-daisy-discount-modal-close]')?.focus({ preventScroll: true });
    });
  };

  const closeDaisyDiscountModal = (modal) => {
    if (!modal || modal.hidden) return;
    const state = getState(modal);
    modal.classList.remove('is-open');
    restoreBodyOverflow(state.previousBodyOverflow);
    state.closeTimer = window.setTimeout(() => {
      modal.hidden = true;
      resetDaisyDiscountModalSuccess(modal);
      state.closeTimer = null;
      if (state.previousFocus && typeof state.previousFocus.focus === 'function') {
        state.previousFocus.focus({ preventScroll: true });
      }
    }, 260);
  };

  document.addEventListener('click', (event) => {
    const openButton = event.target.closest('[data-daisy-discount-modal-open]');
    if (openButton) {
      event.preventDefault();
      const popup = openButton.closest('[data-daisy-discount-popup]');
      const targetSelector = openButton.getAttribute('data-daisy-discount-modal-open');
      const modal = targetSelector
        ? document.querySelector(targetSelector)
        : popup?.querySelector('[data-daisy-discount-modal]');
      openDaisyDiscountModal(modal, openButton);
      return;
    }

    const closeButton = event.target.closest('[data-daisy-discount-modal-close]');
    if (closeButton) {
      event.preventDefault();
      closeDaisyDiscountModal(closeButton.closest('[data-daisy-discount-modal]'));
      return;
    }

    if (event.target.matches('[data-daisy-discount-modal]')) {
      closeDaisyDiscountModal(event.target);
    }
  });

  window.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('[data-daisy-discount-modal]:not([hidden])').forEach(closeDaisyDiscountModal);
  });

  const scheduleDaisyDiscountAutoOpen = () => {
    document.querySelectorAll('[data-daisy-discount-auto-open-delay]').forEach((modal) => {
      if (modal.dataset.daisyDiscountAutoOpenScheduled === 'true') return;
      modal.dataset.daisyDiscountAutoOpenScheduled = 'true';
      const delay = Number.parseInt(modal.dataset.daisyDiscountAutoOpenDelay || '3000', 10);
      window.setTimeout(() => {
        if (modal.hidden) {
          openDaisyDiscountModal(modal, null);
        }
      }, Number.isFinite(delay) ? delay : 3000);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleDaisyDiscountAutoOpen, { once: true });
  } else {
    scheduleDaisyDiscountAutoOpen();
  }
}
